// console.log('Ready javascript');

document.addEventListener('DOMContentLoaded', function () {
var header = document.getElementById('header');
  if (!header) return;

  var lastScrollY = window.pageYOffset || 0;
  var ticking = false;
  var threshold = 60; // px antes de activar clase

  function update() {
    var currentY = window.pageYOffset || 0;

    if (currentY > threshold) {
      header.classList.add('is-active');
    } else {
      header.classList.remove('is-active');
    }

    ticking = false;
  }

  function onScroll() {
    lastScrollY = window.pageYOffset || 0;

    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  
});